import * as React from 'react';

class Hof extends React.Component {

    public render() {
        return (
            <div>
                Hof
            </div>
        );
    }
}

export default Hof;



// WEBPACK FOOTER //
// ./src/Hof/Hof.tsx